"use strict";

angular.module("licensure.services").factory("Users", [
    "$http",
    "$q",
    "$rootScope",
    function($http, $q, $rootScope) {
        return {
            get: function(args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            unsubscribe: function (args) {
                var d = $q.defer();
                
                $http
                    .get(apiLocation + "/api/users/unsubscribe", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPublicSearchUser: function (args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users/getPublicSearchUser", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getForService: function(args) {
                var d = $q.defer();
                args.forService = true;
                $http
                    .get(apiLocation + "/api/users", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getNewUser: function() {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users/getnew", {})
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserObject: function(args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users/getobject", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            lookupUsername: function(args) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/users/lookupUsername", {
                        last_name: args.last_name,
                        account_identifier: args.account_identifier,
                        birth_date: args.birth_date,
                        password: args.password,
                        phone: args.phone,
                        email: args.email,
                        ssn: args.ssn,
                        street: args.street,
                        enterprise_id: args.enterprise_id
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserbyEmail: function (email, userID) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/users/emailCheck', {
                        params: {
                            userID: userID,
                            email: email
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            saveEmail: function (args) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/users/saveemail", {
                        user_id: args.user_id,
                        email: args.new_email,
                        enterprise_id: args.enterprise_id
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            forgotPassword: function(args) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/users/forgotpassword", {
                        last_name: args.last_name,
                        user_name: args.user_name,
                        email: args.email,
                        enterprise_id: args.enterprise_id,
                        is_public: args.is_public
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getResetToken: function(args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users/getresettoken", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPasswordRequirements: function(args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/users/getpasswordrequirements", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getPasswordHistory: function(args) {
                var d = $q.defer();
                $http
                    .get(apiLocation + "/api/userpasswordhistory", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            checkPasswordHistory: function(args) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/userpasswordhistory/check", {
                        user_id: args.user_id,
                        pass: args.pass,
                        top: args.top
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            resetPassword: function(args) {
                var d = $q.defer();
                $http
                    .post(apiLocation + "/api/users/resetpassword", {
                        user_id: args.user_id,
                        username: args.username,
                        password: args.password,
                        enterprise_id: args.enterprise_id,
                        is_public: args.is_public
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            query: function(licenseRuleIds) {
                var d = $q.defer();

                $http
                    .post(apiLocation + "/api/users/query", {
                        licenseRuleIds: licenseRuleIds
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            search: function(args, timeout) {
                var d = $q.defer();

                if (args.search == null || args.search == undefined) {
                    //There should be a search, since this is only used by typeaheads
                    //So avoid unnecessary calls to the backend
                    d.resolve(null);
                }
                else {
                    $http
                        .get(apiLocation + "/api/users/search", {
                            params: args,
                            timeout: timeout != null ? timeout.promise : null
                        })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            d.resolve(response.data);
                        });
                }

                return d.promise;
            },

            searchByService: function (args, timeout) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/users/searchByService', {
                        params: args,
                        timeout: (timeout != null ? timeout.promise : null)
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.resolve(response.data);
                    });

                return d.promise;
            },

            searchUsersNotInService: function (args, timeout) {
                var d = $q.defer();

                if (args.search == null || args.search == undefined) {
                    //If there is no search, it will return null anyway.
                    //So avoid unnecessary calls to the backend
                    d.resolve(null);
                }
                else {
                    $http
                        .get(apiLocation + '/api/users/searchUsersNotInService', {
                            params: args,
                            timeout: (timeout != null ? timeout.promise : null)
                        })
                        .then(function (response) {
                            d.resolve(response.data);
                        })
                        .catch(function (response) {
                            d.resolve(response.data);
                        });
                }

                return d.promise;
            },

            validateUsername: function(args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/users/validateusername", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByID: function(id, getLess, userInfo) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/users/" + id, {
                        params: {
                            getLess: getLess,
                            userInfo: userInfo
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function(user, enterpriseID) {
                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/Users/";
                if (!isUndefined(user.id) && user.id != null) {
                    method = "PUT";
                    url += user.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        user: user,
                        enterpriseID: enterpriseID
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            eliteLookup: function(args) {
                var d = $q.defer();
                args.enterpriseID = $rootScope.enterpriseID;

                $http
                    .get(apiLocation + "/api/elite/userlookup", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            publicLookupUser: function(args) {
                var d = $q.defer();

                var newArgs = {
                    enterprise_id: args.enterprise_id,
                    first_name: args.first_name,
                    last_name: args.last_name,
                    suffix: args.suffix,
                    primaryCertification: args.primary_license_number,
                    applicationCertificationId:
                        args.application_certification_id,
                    applicationLevel: args.application_level_id,
                    certLevel: args.certification_level_id,
                    birth_date: args.date_of_birth,
                    records_offset: args.records_offset,
                    records_total: args.records_total,
                    sort_fields: args.sort_fields,
                    sort_direction: args.sort_direction,
                    userID: args.userID,
                    from_search: args.from_search,
                    account_identifier: args.account_identifier,
                    service_affiliation_county: args.service_affiliation_county,
                    national_ems_id: args.national_ems_id
                };

                $http
                    .post(apiLocation + "/api/users/PublicLookupUser", newArgs)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserLookupCount: function(args) {
                var d = $q.defer();

                var newArgs = {
                    enterprise_id: args.enterprise_id,
                    first_name: args.first_name,
                    last_name: args.last_name,
                    suffix: args.suffix,
                    primaryCertification: args.primary_license_number,
                    applicationCertificationId:
                        args.application_certification_id,
                    applicationLevel: args.application_level_id,
                    certLevel: args.certification_level_id,
                    birth_date: args.date_of_birth,
                    account_identifier: args.account_identifier,
                    service_affiliation_county: args.service_affiliation_county,
                    national_ems_id: args.national_ems_id
                };

                $http
                    .post(
                        apiLocation + "/api/users/getuserlookupcount",
                        newArgs
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserAlerts: function(args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/users/getuseralerts", {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserCertifications: function (user_id, detail, enterprise_id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/users/getusercertifications", {
                        params: {
                            user_id: user_id,
                            detail: detail,
                            enterprise_id: enterprise_id
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function () {
                        // handle error
                    });

                return d.promise;
            },

            getUserEMSLevels: function(args) {
                var d = $q.defer();

                $http
                    .get(
                        apiLocation +
                            "/api/users/getuseremslevels/" +
                            args.userID
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserEndorsements: function(args) {
                var d = $q.defer();

                $http
                    .get(
                        apiLocation +
                            "/api/users/getuserendorsements/" +
                            args.userID
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserInstructorLevels: function(args) {
                var d = $q.defer();

                $http
                    .get(
                        apiLocation +
                            "/api/users/getuserinstructorlevels/" +
                            args.userID
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserEvaluatorLevels: function(args) {
                var d = $q.defer();

                $http
                    .get(
                        apiLocation +
                            "/api/users/getuserevaluatorlevels/" +
                            args.userID
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserInstructingTopics: function(args) {
                var d = $q.defer();

                $http
                    .get(
                        apiLocation +
                            "/api/users/getuserinstructingtopics/" +
                            args.userID
                    )
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getUserByServicePersonnelID: function (personnelID, serviceID) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/users/getUsersByServicePersonnelID', {
                        params: {
                            serviceID: serviceID,
                            personnelID: personnelID
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getUserAddressInfo: function (userId) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/User/AddressInfo/' + userId, {
                        params: {}
                    }).then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },

            getServiceUsersForReimbursement: function (serviceId) {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/users/serviceUsersReimbursement', {
                        params: {
                            serviceID: serviceId
                        }
                    }).then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });
                return d.promise;
            },
        };
    }
]);
